import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-new-report-detail',
  templateUrl: './new-report-detail.component.html',
  styleUrls: ['./new-report-detail.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class NewReportDetailComponent implements OnInit, AfterViewInit {

  @ViewChild('insertedDateTpl') insertedDateTpl: TemplateRef<any>;
  @ViewChild('birthDateTpl') birthDateTpl: TemplateRef<any>;
  @ViewChild('statusTpl') statusTpl: TemplateRef<any>;
  @ViewChild('indrizzoTpl') indrizzoTpl: TemplateRef<any>;
  @ViewChild('scoreTpl') scoreTpl: TemplateRef<any>;
  @ViewChild('worstTpl') worstTpl: TemplateRef<any>;
  @ViewChild('stimaTpl') stimaTpl: TemplateRef<any>;
  @ViewChild('eventiTpl') eventiTpl: TemplateRef<any>;
  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;
  
  data: any;
  rows = [];
  columns = [];
  requestNumber:any;

  header: string[] = [];
  excelRows = [];

  constructor(
    private reportService: ReportService,
    private route: ActivatedRoute,
    private commonUtilsService: CommonUtilService,
    private datePipe: DatePipe,
    private spinnerService: SpinnerService,
    private router: Router) {

    this.spinnerService.start();
    this.requestNumber = this.route.snapshot.paramMap.get('requestNumber');

    this.reportService.getReportDetail(this.requestNumber).subscribe(data => {
      /* console.log(data); */
      this.data = data;
      if (data && data.candidates) {
        this.rows = data.candidates;
        /* console.log(this.rows); */
        /* console.log(this.rows[0]); */
        /* console.log(this.rows[0].crifResult); */
      }
      this.spinnerService.stop();
    });
  }

  ngAfterViewInit(): void {
    this.columns = [
      { name: 'Email candidato', prop: 'email', sortable: true, width: 220, resizeable: false },
      { name: 'Stato richiesta', prop:'status', cellTemplate: this.statusTpl, sortable: true, width: 150, resizeable: false },
      { name: 'Data invio Report', cellTemplate: this.insertedDateTpl, width: 170, resizeable: false, comparator: this.columnInsertedDateComparator.bind(this) },
      { name: 'Nome', prop: 'firstName', maxWidth: 150, resizeable: false },
      { name: 'Cognome', prop: 'lastName', maxWidth: 150, resizeable: false },
      { name: 'Indirizzo', cellTemplate: this.indrizzoTpl, width: 280, resizeable: false },
      { name: 'Codice fiscale', prop: 'codiceFiscale', maxWidth: 250, resizeable: false },
      { name: 'Data di nascita', cellTemplate: this.birthDateTpl, maxWidth: 150, resizeable: false, comparator: this.columnBirthDateComparator.bind(this) },
      { name: 'Score Degrade', cellTemplate: this.scoreTpl, sortable: true, width: 150, resizeable: false },
      { name: 'Worst', cellTemplate: this.worstTpl, sortable: true, width: 80, resizeable: false },
      { name: 'Stima Reddito', cellTemplate: this.stimaTpl, sortable: true, width: 130, resizeable: false },
      { name: 'Eventi Negativi', cellTemplate: this.eventiTpl, sortable: true, width: 150, resizeable: false },
      { name: 'Azioni', sortable: false, width: 200, resizeable: false, cellTemplate: this.actionCellTpl }
    ];
  }


  ngOnInit(): void {
    this.spinnerService.start();
    this.commonUtilsService.translateLang("HRWE.PAGE_TITLE.REPORT_DETAIL");
    this.spinnerService.stop();
  }

  parseInsertedDate(val) {
    if (val != null) {
      let outputDate = this.datePipe.transform(new Date(val), 'dd/MM/yyyy HH:mm');
      return outputDate;
    }
  }

  parseDateOfBirth(val) {
    if (val != null) {
      let outputDate = this.datePipe.transform(new Date(val), 'dd/MM/yyyy');
      return outputDate;
    }
  }

  columnInsertedDateComparator(propA, propB, rowA, rowB) {
    if (new Date(rowA.insertedDate) < new Date(rowB.insertedDate)) { return -1; }
    if (new Date(rowA.insertedDate) > new Date(rowB.insertedDate)) { return 1; }
  }

  columnBirthDateComparator(propA, propB, rowA, rowB) {
    if (new Date(rowA.dateOfBirth) < new Date(rowB.dateOfBirth)) { return -1; }
    if (new Date(rowA.dateOfBirth) > new Date(rowB.dateOfBirth)) { return 1; }
  }

  goToDetail(uuid) {
    this.router.navigate([`/report/${this.requestNumber}/candidate/detail/${uuid}`]);
  }

exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilsService.ExportAsExcel('Utenti', this.excelRows, "Candidates ("+this.data.referencePerson+" - "+this.data.requestNumber+") - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilsService.ExportAsPDF(true, this.header, this.excelRows, "Candidates ("+this.data.referencePerson+" - "+this.data.requestNumber+") - HRWE.pdf");
    
  }

  exportRows() {

    var formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 3,
    });

    this.header = ['Email candidato', 'Stato richiesta', 'Data invio Report', 'Nome', 'Cognome', 'Indirizzo', 'Codice fiscale', 'Data di nascita', 'Score Degrade', 'Worst', 'Stima Reddito', 'Eventi Negativi'];

    let arr = this.rows.map(rec => {
      return {
        'Email candidato' : rec.email,
        'Stato richiesta' : this.commonUtilsService.decodeCandidateStatus(rec.status),
        'Data invio Report' : this.datePipe.transform(rec.insertedDate, 'dd/MM/yyyy'),
        'Nome' : rec.firstName,
        'Cognome' : rec.lastName,
        'Indirizzo' : rec.via != null ? rec.via+" "+rec.indirizzo+" "+rec.civico+", "+rec.citta+" "+rec.cap+", "+rec.provincia : '',
        'Codice fiscale' : rec.codiceFiscale,
        'Data di nascita' : this.datePipe.transform(rec.dateOfBirth, 'dd/MM/yyyy'),
        'Score Degrade' : rec.crifResult && rec.crifResult.degradationScore ? this.commonUtilsService.getRoundUpScoreVal(rec.crifResult.degradationScore) : '',
        'Worst': rec.crifResult && rec.crifResult.degradationScoreFlag5percentage ? this.commonUtilsService.getWorstCalResult(rec.crifResult.degradationScoreFlag5percentage) : '',
        'Stima Reddito': rec.crifResult && rec.crifResult.averageIncome ? formatter.format(Number(rec.crifResult.averageIncome)) : '',
        'Eventi Negativi' : rec.cribisResult && rec.cribisResult.relevanceNegativity ? rec.cribisResult.relevanceNegativity : ''
      }
    });

    return arr;
  }

}
